///<reference path="types/StoreState.tsx"/>
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import { createStore, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';
import reducers from 'src/reducers';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Provider } from 'react-redux';
import { persistStore, persistReducer } from 'redux-persist'

import './index.css';
import registerServiceWorker from './registerServiceWorker';
import storage from 'redux-persist/lib/storage'
import {PersistGate} from "redux-persist/integration/react"; // defaults to localStorage for web and AsyncStorage for react-native
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import {CreateGifComponent} from "./components/createGifComponent/CreateGifComponent";
import Gifsingle from "./containers/gifSingle/gifsingle";
import UploadGifComponent from "./components/uploadGifComponent/UploadGifComponent";
import UploadPhotosComponent from "./components/uploadPhotosComponent";
import UploadVideoComponent from "./components/uploadVideoComponent/UploadVideoComponent";
import UserProfile from "./containers/userProfile/UserProfile";
import UserFavorites from "./containers/userFavorites/UserFavorites";
import Search from "./containers/search/Search";
import configureStore from './configureStore/configureStore';
import YoutubLinkComponent from "./components/youtubeLinkComponent/YoutubLinkComponent";
import Mediagif from "./containers/mediaGif/Mediagif";

const { persistor, store } = configureStore()
import { slide as Menu } from 'react-burger-menu'
import FooterComponent from "./components/footerComponent/FooterComponent";

ReactDOM.render(

    <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>

                    <BrowserRouter>
                        <Switch>

                    <Route path="/" exact component={App} />
                    <Route path="/gif/:id" exact component={Gifsingle} />
                    <Route path="/uploadgif" component={UploadGifComponent} />
                    <Route path="/creategif" exact component={CreateGifComponent} />
                    <Route path="/creategifVideo" exact component={UploadVideoComponent} />
                    <Route path="/profile" exact component={UserProfile} />
                    <Route path="/favorites" exact component={UserFavorites} />
                    <Route path="/creategifPhotos" exact component={UploadPhotosComponent} />
                    <Route path="/creategifYoutube" exact component={YoutubLinkComponent} />
                    <Route path="/search" exact component={Search} />
                    <Route path="/media_gif/:id" exact component={Mediagif} />
                </Switch>
            </BrowserRouter>
        </PersistGate>
    </Provider>,
  document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx